import './BurgerMenu.css';
import { Link } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import BurgerMenuItem from './BurgerMenuItem.jsx';
import SalesPhone from '../SalesPhone/SalesPhone.jsx';
import {
  EMAIL,
  EMAIL_HREF,
  FOOTER_ADDRESSES,
  PHONE_DISPLAY,
  PHONE_HREF,
  STRELETS_EMAIL,
  STRELETS_EMAIL_HREF,
} from '../../constants/contactInfo.js';
import { navigationItems } from '../../constants/navigationItems.js';
function BurgerMenu() {
  return (
    <div className="burgerMenu">
      <div className="burgerMenu__container">
        <ul className="burgerMenu__list">
          {navigationItems.map((item) => (
            <BurgerMenuItem key={item.path} {...item} />
          ))}
        </ul>
        <Link to="/personal-account/" className="burgerMenu__account-link">
          <FaUser />
          Личный кабинет
        </Link>
      </div>
      <div className="burgerMenu__footer">
        <div className="burgerMenu__footer-container">
          <div className="burgerMenu__footer-contacts">
            <a
              href={PHONE_HREF}
              className="burgerMenu__footer-phone"
              target="_blanck"
            >
              <FaPhone /> {PHONE_DISPLAY}
            </a>
            <SalesPhone className="burgerMenu__footer-phone" />
            <a
              href={EMAIL_HREF}
              className="burgerMenu__footer-email"
              target="_blanck"
            >
              <FaEnvelope /> {EMAIL}
            </a>
            <a
              href={STRELETS_EMAIL_HREF}
              className="burgerMenu__footer-email"
              target="_blanck"
            >
              <FaEnvelope /> {STRELETS_EMAIL}
            </a>
          </div>
          <div className="burgerMenu__footer-socials" aria-label="Социальные сети">
            <a
              href="https://vk.ru/id607995315"
              className="burgerMenu__footer-social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="ВКонтакте"
            >
              <img
                src="/images/socials/VK.svg.webp"
                alt=""
                className="burgerMenu__footer-social-icon"
              />
            </a>
            <a
              href="https://max.ru/join/yLUnVZOKZLgNUSNxL91fDeSqhEm7MK9yCIMvaGrlODE"
              className="burgerMenu__footer-social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="MAX"
            >
              <img
                src="/images/socials/MAX.svg.webp"
                alt=""
                className="burgerMenu__footer-social-icon"
              />
            </a>
          </div>
          <div className="burgerMenu__footer-address">
            <div className="burgerMenu__footer-address-heading">
              <FaMapMarkerAlt className="burgerMenu__footer-address-icon" />
              <span className="burgerMenu__footer-address-title">Адреса</span>
            </div>
            <div className="burgerMenu__footer-address-list">
              {FOOTER_ADDRESSES.map((address) => (
                <div
                  key={address.text}
                  className="burgerMenu__footer-address-item"
                >
                  <span className="burgerMenu__footer-address-badge">
                    {address.label}
                  </span>
                  <span className="burgerMenu__footer-address-text">
                    {address.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <p className="burgerMenu__footer-copyright">
          © {new Date().getFullYear()} СОО ВДПО. Все права защищены.
        </p>
      </div>
    </div>
  );
}

export default BurgerMenu;
